import blog1 from '../img/films/The Ring.jpg';
import blog2 from '../img/films/orai.png';
import blog3 from '../img/films/drirotai.png';
import blog4 from '../img/films/bhanga-kanch.jpg';
import blog5 from '../img/films/shongjom.jpg';
import blog6 from '../img/films/eyesWide.png';

const allFilms = [
    {
        id: 1,
        image: blog5,
        title: 'Shongjom,Official Selection,Star Brac U Short Film Festival 2018.',
        link: 'https://drive.google.com/file/d/1zM1OClEolqadA3WvuSI1iexmDVvX6AU9/view?usp=drive_link',
        date : '04',
        month: 'Aug',
        year: '2020'
    },
    {
        id: 2,
        image: blog3,
        title: 'Drirotai Lal Sobuj (Official Nomination Peace Film Festival Bangladesh 2019',
        link: 'https://drive.google.com/file/d/18eb5KDS3O60WPRAT_oS3HwpzthBqMe1Z/view?usp=drive_link',
        date : '15',
        month: 'Jun',
        year: '2018'
    },
    {
        id: 3,
        image: blog2,
        title: 'Orai bangladesh (The Unsung Heroes)',
        link: 'https://drive.google.com/file/d/1Xuyk54RGA722YghFFHK-o1cdc7hGC55d/view?usp=drive_link',
        date : '09',
        month: 'Dec',
        year: '2019'
    },
    {
        id: 4,
        image: blog4,
        title: 'Bhanga Kanch',
        link: 'https://www.youtube.com/watch?v=tq7vv5tNP7g&t=37s',
        date : '04',
        month: 'Aug',
        year: '2020'
    },
    {
        id: 5,
        image: blog6,
        title: 'Eyes Wide Shut (Best Cinematography & Editing Award Nsu Eng111 Short Cine Fest 2020) - The whole film was shot on Samsung S9 mobile',
        link: 'https://drive.google.com/file/d/1cAAc4JfzzhJBobzzzfDZLTP-uTh9r192/view?usp=sharing',
        date : '21',
        month: 'Mar',
        year: '2020'
    },
    {
        id: 6,
        image: blog1,
        title: 'The Ring',
        link: 'https://drive.google.com/file/d/1-n0iHgLVdnAaq1w1zs5El83WMKdllOFU/view?usp=drive_link',
        date : '21',
        month: 'Mar',
        year: '2020'
    }
];

export default allFilms;

